import React from 'react';
import { Loader2, Calculator, Users, TrendingUp } from 'lucide-react';

interface ProcessingScreenProps {
  fileName?: string;
}

const ProcessingScreen: React.FC<ProcessingScreenProps> = ({ fileName }) => {
  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="card p-8 text-center">
          <div className="space-y-6">
            {/* Animated Loading Icon */}
            <div className="flex justify-center">
              <div className="relative">
                <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
                  <Loader2 className="w-8 h-8 text-primary-600 animate-spin" />
                </div>
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-success-500 rounded-full flex items-center justify-center">
                  <Calculator className="w-3 h-3 text-white" />
                </div>
              </div>
            </div>
            
            {/* Main Message */}
            <div className="space-y-2">
              <h2 className="text-2xl font-semibold text-secondary-900">
                Calculating Hot Seat Scores
              </h2>
              <p className="text-secondary-600">
                Analyzing member contributions, attendance, and experience...
              </p>
            </div>
            
            {/* File Info */}
            {fileName && (
              <div className="p-4 bg-secondary-50 rounded-lg">
                <div className="flex items-center justify-center space-x-2 text-sm text-secondary-600">
                  <Users className="w-4 h-4" />
                  <span>Processing: {fileName}</span>
                </div>
              </div>
            )}
            
            {/* Progress Steps */}
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-sm">
                <div className="w-2 h-2 bg-success-500 rounded-full"></div>
                <span className="text-secondary-600">Parsing Excel data</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <div className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></div>
                <span className="text-secondary-600">Calculating contribution gaps</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <div className="w-2 h-2 bg-secondary-300 rounded-full"></div>
                <span className="text-secondary-400">Computing final scores</span>
              </div>
              <div className="flex items-center space-x-3 text-sm">
                <div className="w-2 h-2 bg-secondary-300 rounded-full"></div>
                <span className="text-secondary-400">Ranking members</span>
              </div>
            </div>
            
            {/* Fun Fact */}
            <div className="p-4 bg-primary-50 rounded-lg">
              <div className="flex items-center justify-center space-x-2 text-sm text-primary-700">
                <TrendingUp className="w-4 h-4" />
                <span>Hot Seat members typically give 3x more business than they receive</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessingScreen;
